import { ca } from '@cian/analytics';
import { TRegularInfrastructureType } from '../../../types/map';
import { getMapYears } from '../../../utils/map';

interface ITrackYearClickParams {
  year: number;
  objectType: TRegularInfrastructureType;
}

export function trackYearClick({ year, objectType }: ITrackYearClickParams) {
  const mapYears = getMapYears();
  const position = mapYears.indexOf(year) + 1;

  ca('eventSite', {
    action: 'click_sopr',
    category: 'Infrastructure',
    label: 'timeline',
    name: 'oldevent',
    page: {
      pageType: 'CardJK',
      siteType: 'desktop',
      extra: {
        block_type: 'future',
        position,
        year,
        object_type: objectType,
      },
    },
    useLastProducts: true,
  });
}
